export class CountryDto {
    code: string;
    label: string;

    constructor(code: string) {
        this.code = code;
        this.label = `country:country.${code}`;
    }
}
